import { Component, OnInit } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { HomeService } from '../home/home.service';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss']
})

export class PricingComponent implements OnInit {

  prices: any;
  pricingData: any = '';
  colorCodes: any[] = ['#2548DB', '#FF9900', '#00ABAB', '#A1887F', '#607D8B', '#039BE5', '#009688'];

  constructor(
    private homeService: HomeService,
    private ngxService: NgxUiLoaderService) { }

  ngOnInit() {
    this.getPrices();
  }

  private getPrices() {
    this.ngxService.startLoader('loader-03');
    this.homeService.getPrices().subscribe((prices) => {
      const plans = Array.isArray(prices?.plans) ? prices.plans : [];
      this.pricingData = plans;
      // Default to monthly plan
      const monthly = this.pricingData.find((p: any) => (p?.period || '').toUpperCase() === 'MONTHLY') || this.pricingData[0];
      this.prices = monthly || null;
      this.ngxService.stopLoader('loader-03');
    }, (error) => {
      this.ngxService.stopLoader('loader-03');
    })
  }

  togglePlan(yearPlan): void {
    const desired = (yearPlan === 'YEARLY') ? 'YEARLY' : 'MONTHLY';
    const plan = this.pricingData.find((p: any) => (p?.period || '').toUpperCase() === desired) || this.pricingData[0];
    this.prices = plan || null;
  }

  onMoreClick(cardDetails) {
  }

}
